export enum ApiProjections {
  DETAILED = 'DETAILED',
  ALL = 'ALL',
  MIN = 'MIN',
}
